export default __webpack_public_path__ + "static/media/YAS0910.34I-41427_-24740_0.6eb52e74.jpg";